





















import {
  Vue, Component, Mixins, Prop, Watch,
} from 'vue-property-decorator';

import _ from 'lodash';

@Component
export default class extends Mixins() {
  @Prop() value!: any;

  @Prop({ default: 'default' }) mode!: string;

  @Prop({ default: true }) allowClear!: boolean;

  value1: any = null;

  data: any[] = [];

  isMounted = false;

  @Watch('value')
  watchValue(val: any, oldVal: any) {
    if (val) {
      if (Array.isArray(val)) {
        this.value1 = val;
        this.fetch1(this.value1);
      } else {
        this.value1 = String(val);
        this.fetch(this.value1);
      }
    } else {
      this.value1 = null;
    }
  }

  fetch(value: any) {
    this.$store
      .dispatch('customer/selectdata', {
        keyword: value,
      })
      .then((res: any) => {
        if (res && res.Data && res.Data !== '{}') {
          this.data = res.Data;
        } else {
          this.data = [];
        }
      });
  }

  fetch1(customerIds: any) {
    if (!_.isArray(customerIds)) {
      customerIds = [customerIds];
    }
    this.$store
      .dispatch('customer/selectdata', {
        customer_ids: customerIds,
      })
      .then((res: any) => {
        if (res && res.Data && res.Data !== '{}') {
          this.data = res.Data;
        } else {
          this.data = [];
        }
      });
  }

  handleSearch(value: string) {
    this.fetch(value);
  }

  handleChange(value: string) {
    // console.log(value)
    this.value1 = value;
    this.$emit('change', value);
    this.fetch(value);
  }

  mounted() {
    const query = { ...this.$route.query };

    let { value } = this;

    if (query.customer_id) {
      value = query.customer_id;
    }

    if (value) {
      if (value || value.length > 0) {
        this.value1 = value;
        if (!_.isArray(this.value1)) {
          this.value1 = this.value1.toString();
        }
        this.fetch1(this.value1);
      }
    }
  }
}
